import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useUpdatePassword = (): any => {
  const { isLoading, status, error, send } = useRequest({
    url: '/api/v1/auth/me',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const updatePassword = (body: { password: string; oldPassword: string }) => {
    send(body).then();
  };

  return {
    isLoading,
    error: error ? { message: error?.response?.data?.errors?.oldPassword } : null,
    updatePassword,
    status,
  };
};
